import {
  createRequestTypes,
  START,
  SUCCESS,
  ERROR,
} from '@modules/appraisal/actions/global';
import { makeApiActionCreatorV3 } from '@actions/utils';
import * as api from '@modules/litigation/api/arbitration';
import * as eventApi from '@modules/events/api/event';

const namespace = 'LITIGATION';

export const ARBITRATION_RESET_DATA = `${namespace}/ARBITRATION_RESET_DATA`;
export const ARBITRATION_FETCH_START = `${namespace}/ARBITRATION_FETCH_START`;
export const ARBITRATION_FETCH_SUCCESS = `${namespace}/ARBITRATION_FETCH_SUCCESS`;
export const ARBITRATION_FETCH_ERROR = `${namespace}/ARBITRATION_FETCH_ERROR`;

export const ARBITRATION_UPDATE_START = `${namespace}/ARBITRATION_UPDATE_START`;
export const ARBITRATION_UPDATE_SUCCESS = `${namespace}/ARBITRATION_UPDATE_SUCCESS`;
export const ARBITRATION_UPDATE_ERROR = `${namespace}/ARBITRATION_UPDATE_ERROR`;

export const ARBITRATION_DELETE_START = `${namespace}/ARBITRATION_DELETE_START`;
export const ARBITRATION_DELETE_SUCCESS = `${namespace}/ARBITRATION_DELETE_SUCCESS`;
export const ARBITRATION_DELETE_ERROR = `${namespace}/ARBITRATION_DELETE_ERROR`;

export const ARBITRATION_VALIDATE_START = `${namespace}/ARBITRATION_VALIDATE_START`;
export const ARBITRATION_VALIDATE_SUCCESS = `${namespace}/ARBITRATION_VALIDATE_SUCCESS`;
export const ARBITRATION_VALIDATE_ERROR = `${namespace}/ARBITRATION_VALIDATE_ERROR`;

export const INSERT_ARBITRATION = createRequestTypes(
  `${namespace}/INSERT_ARBITRATION`,
);
export const insertArbitration = makeApiActionCreatorV3(
  api.insertArbitration,
  INSERT_ARBITRATION[START],
  INSERT_ARBITRATION[SUCCESS],
  INSERT_ARBITRATION[ERROR],
);

export const FETCH_ARBITRATION = createRequestTypes(
  `${namespace}/FETCH_ARBITRATION`,
);
export const fetchArbitration = makeApiActionCreatorV3(
  api.fetchArbitration,
  FETCH_ARBITRATION[START],
  FETCH_ARBITRATION[SUCCESS],
  FETCH_ARBITRATION[ERROR],
);

export const FETCH_ARBITRATION_HEADERS = createRequestTypes(
  `${namespace}/FETCH_ARBITRATION_HEADERS`,
);
export const fetchArbitrationHeaders = makeApiActionCreatorV3(
  api.fetchArbitrationHeaders,
  FETCH_ARBITRATION_HEADERS[START],
  FETCH_ARBITRATION_HEADERS[SUCCESS],
  FETCH_ARBITRATION_HEADERS[ERROR],
);

export const FETCH_ARBITRATION_STATUS = createRequestTypes(
  `${namespace}/FETCH_ARBITRATION_STATUS`,
);
export const fetchArbitrationStatus = makeApiActionCreatorV3(
  api.fetchArbitrationStatus,
  FETCH_ARBITRATION_STATUS[START],
  FETCH_ARBITRATION_STATUS[SUCCESS],
  FETCH_ARBITRATION_STATUS[ERROR],
);

export const ARBITRATION_STATUS_UPDATE = createRequestTypes(
  `${namespace}/ARBITRATION_STATUS_UPDATE`,
);
export const updateArbitrationStatus = makeApiActionCreatorV3(
  api.updateAbritrationStatus,
  ARBITRATION_STATUS_UPDATE[START],
  ARBITRATION_STATUS_UPDATE[SUCCESS],
  ARBITRATION_STATUS_UPDATE[ERROR],
);

export const ARBITRATION_GENERAL_UPDATE = createRequestTypes(
  `${namespace}/ARBITRATION_GENERAL_UPDATE`,
);
export const updateArbitrationGeneral = makeApiActionCreatorV3(
  api.updateArbitrationGeneral,
  ARBITRATION_GENERAL_UPDATE[START],
  ARBITRATION_GENERAL_UPDATE[SUCCESS],
  ARBITRATION_GENERAL_UPDATE[ERROR],
);

export const SET_ACTIVE_ARBITRATION = `${namespace}/SET_ACTIVE_ARBITRATION`;
export const setActiveArbitration = payload => ({
  type: SET_ACTIVE_ARBITRATION,
  payload,
});
export const RESET_ACTIVE_ARBITRATION = `${namespace}/RESET_ACTIVE_ARBITRATION`;
export const resetActiveArbitration = () => ({
  type: RESET_ACTIVE_ARBITRATION,
});

export const FETCH_DROPDOWNS = createRequestTypes(
  `${namespace}/FETCH_DROPDOWNS`,
);

export const fetchDropdowns = makeApiActionCreatorV3(
  api.fetchDropdowns,
  FETCH_DROPDOWNS[START],
  FETCH_DROPDOWNS[SUCCESS],
  FETCH_DROPDOWNS[ERROR],
);

export function resetArbitrationData() {
  return async dispatch => {
    dispatch({ type: ARBITRATION_RESET_DATA });
  };
}

export const FETCH_ARBITRATION_PRESENTATION = createRequestTypes(
  `${namespace}/FETCH_ARBITRATION_PRESENTATION`,
);
export const fetchArbitrationPresentation = makeApiActionCreatorV3(
  api.fetchArbitrationPresentation,
  FETCH_ARBITRATION_PRESENTATION[START],
  FETCH_ARBITRATION_PRESENTATION[SUCCESS],
  FETCH_ARBITRATION_PRESENTATION[ERROR],
);

export const DELETE_ARBITRATION_PRESENTATION = createRequestTypes(
  `${namespace}/DELETE_ARBITRATION_PRESENTATION`,
);
export const deleteArbitrationPresentation = makeApiActionCreatorV3(
  api.deleteArbitrationPresentation,
  DELETE_ARBITRATION_PRESENTATION[START],
  DELETE_ARBITRATION_PRESENTATION[SUCCESS],
  DELETE_ARBITRATION_PRESENTATION[ERROR],
);

export const PUBLISH_ARBITRATION_PRESENTATION = createRequestTypes(
  `${namespace}/PUBLISH_ARBITRATION_PRESENTATION`,
);
export const publishArbitrationPresentation = makeApiActionCreatorV3(
  api.publishArbitrationPresentation,
  PUBLISH_ARBITRATION_PRESENTATION[START],
  PUBLISH_ARBITRATION_PRESENTATION[SUCCESS],
  PUBLISH_ARBITRATION_PRESENTATION[ERROR],
);

export const FETCH_ARBITRATION_NOTES = createRequestTypes(
  `${namespace}/FETCH_ARBITRATION_NOTES`,
);
export const fetchArbitrationNotes = makeApiActionCreatorV3(
  api.fetchArbitrationNotes,
  FETCH_ARBITRATION_NOTES[START],
  FETCH_ARBITRATION_NOTES[SUCCESS],
  FETCH_ARBITRATION_NOTES[ERROR],
);

export const ADD_ARBITRATION_NOTE = createRequestTypes(
  `${namespace}/ADD_ARBITRATION_NOTE`,
);
export const addArbitrationNote = makeApiActionCreatorV3(
  api.addArbitrationNote,
  ADD_ARBITRATION_NOTE[START],
  ADD_ARBITRATION_NOTE[SUCCESS],
  ADD_ARBITRATION_NOTE[ERROR],
);

export const DELETE_ARBITRATION_NOTE = createRequestTypes(
  `${namespace}/DELETE_ARBITRATION_NOTE`,
);
export const deleteArbitrationNote = makeApiActionCreatorV3(
  api.deleteArbitrationNote,
  DELETE_ARBITRATION_NOTE[START],
  DELETE_ARBITRATION_NOTE[SUCCESS],
  DELETE_ARBITRATION_NOTE[ERROR],
);

export const UPDATE_ARBITRATION_NOTE = createRequestTypes(
  `${namespace}/UPDATE_ARBITRATION_NOTE`,
);
export const updateArbitrationNote = makeApiActionCreatorV3(
  api.updateArbitrationNote,
  UPDATE_ARBITRATION_NOTE[START],
  UPDATE_ARBITRATION_NOTE[SUCCESS],
  UPDATE_ARBITRATION_NOTE[ERROR],
);

export const UPDATE_ARBITRATION_NOTE_TAGS = createRequestTypes(
  `${namespace}/UPDATE_ARBITRATION_NOTE_TAGS`,
);
export const updateArbitrationNoteTags = makeApiActionCreatorV3(
  api.updateArbitrationNoteTags,
  UPDATE_ARBITRATION_NOTE_TAGS[START],
  UPDATE_ARBITRATION_NOTE_TAGS[SUCCESS],
  UPDATE_ARBITRATION_NOTE_TAGS[ERROR],
);

export const FETCH_ARBITRATION_PRESENTATION_DOCUMENTS = createRequestTypes(
  `${namespace}/FETCH_ARBITRATION_PRESENTATION_DOCUMENTS`,
);
export const fetchArbitrationPresentationDocuments = makeApiActionCreatorV3(
  api.fetchArbitrationPresentationDocuments,
  FETCH_ARBITRATION_PRESENTATION_DOCUMENTS[START],
  FETCH_ARBITRATION_PRESENTATION_DOCUMENTS[SUCCESS],
  FETCH_ARBITRATION_PRESENTATION_DOCUMENTS[ERROR],
);

export const INSERT_ARBITRATION_PRESENTATION_DOCUMENT = createRequestTypes(
  `${namespace}/INSERT_ARBITRATION_PRESENTATION_DOCUMENT`,
);
export const insertArbitrationPresentationDocument = makeApiActionCreatorV3(
  api.insertArbitrationPresentationDocument,
  INSERT_ARBITRATION_PRESENTATION_DOCUMENT[START],
  INSERT_ARBITRATION_PRESENTATION_DOCUMENT[SUCCESS],
  INSERT_ARBITRATION_PRESENTATION_DOCUMENT[ERROR],
);

export const DELETE_ARBITRATION_PRESENTATION_DOCUMENTS = createRequestTypes(
  `${namespace}/DELETE_ARBITRATION_PRESENTATION_DOCUMENTS`,
);
export const deleteArbitrationPresentationDocuments = makeApiActionCreatorV3(
  api.deleteArbitrationPresentationDocuments,
  DELETE_ARBITRATION_PRESENTATION_DOCUMENTS[START],
  DELETE_ARBITRATION_PRESENTATION_DOCUMENTS[SUCCESS],
  DELETE_ARBITRATION_PRESENTATION_DOCUMENTS[ERROR],
);

export const FETCH_ARBITRATION_PRESENTATION_DOCUMENT = createRequestTypes(
  `${namespace}/FETCH_ARBITRATION_PRESENTATION_DOCUMENT`,
);
export const fetchArbitrationPresentationDocument = makeApiActionCreatorV3(
  api.fetchArbitrationPresentationDocument,
  FETCH_ARBITRATION_PRESENTATION_DOCUMENT[START],
  FETCH_ARBITRATION_PRESENTATION_DOCUMENT[SUCCESS],
  FETCH_ARBITRATION_PRESENTATION_DOCUMENT[ERROR],
);

export const DELETE_ARBITRATION_PRESENTATION_DOCUMENT = createRequestTypes(
  `${namespace}/DELETE_ARBITRATION_PRESENTATION_DOCUMENT`,
);
export const deleteArbitrationPresentationDocument = makeApiActionCreatorV3(
  api.deleteArbitrationPresentationDocument,
  DELETE_ARBITRATION_PRESENTATION_DOCUMENT[START],
  DELETE_ARBITRATION_PRESENTATION_DOCUMENT[SUCCESS],
  DELETE_ARBITRATION_PRESENTATION_DOCUMENT[ERROR],
);

export const UPDATE_ARBITRATION_PRESENTATION_DOCUMENTS_ORDER = createRequestTypes(
  `${namespace}/UPDATE_ARBITRATION_PRESENTATION_DOCUMENTS_ORDER`,
);
export const updateArbitrationPresentationDocumentsOrder = makeApiActionCreatorV3(
  api.updateArbitrationPresentationDocumentsOrder,
  UPDATE_ARBITRATION_PRESENTATION_DOCUMENTS_ORDER[START],
  UPDATE_ARBITRATION_PRESENTATION_DOCUMENTS_ORDER[SUCCESS],
  UPDATE_ARBITRATION_PRESENTATION_DOCUMENTS_ORDER[ERROR],
);

export const GENERATE_ARBITRATION_PRESENTATION_DOCUMENT = createRequestTypes(
  `${namespace}/GENERATE_ARBITRATION_PRESENTATION_DOCUMENT`,
);
export const generateArbitrationPresentationDocument = makeApiActionCreatorV3(
  api.generateArbitrationPresentationDocument,
  GENERATE_ARBITRATION_PRESENTATION_DOCUMENT[START],
  GENERATE_ARBITRATION_PRESENTATION_DOCUMENT[SUCCESS],
  GENERATE_ARBITRATION_PRESENTATION_DOCUMENT[ERROR],
);

export const FETCH_ARBITRATION_APPRAISER_RECOMMENDATION = createRequestTypes(
  `${namespace}/FETCH_ARBITRATION_APPRAISER_RECOMMENDATION`,
);
export const fetchArbitrationAppraiserRecommendation = makeApiActionCreatorV3(
  api.fetchArbitrationAppraiserRecommendation,
  FETCH_ARBITRATION_APPRAISER_RECOMMENDATION[START],
  FETCH_ARBITRATION_APPRAISER_RECOMMENDATION[SUCCESS],
  FETCH_ARBITRATION_APPRAISER_RECOMMENDATION[ERROR],
);

export const UPDATE_ARBITRATION_APPRAISER_RECOMMENDATION = createRequestTypes(
  `${namespace}/UPDATE_ARBITRATION_APPRAISER_RECOMMENDATION`,
);
export const updateArbitrationAppraiserRecommendation = makeApiActionCreatorV3(
  api.updateArbitrationAppraiserRecommendation,
  UPDATE_ARBITRATION_APPRAISER_RECOMMENDATION[START],
  UPDATE_ARBITRATION_APPRAISER_RECOMMENDATION[SUCCESS],
  UPDATE_ARBITRATION_APPRAISER_RECOMMENDATION[ERROR],
);

export const FETCH_ARBITRATION_EVENTS = createRequestTypes(
  `${namespace}/FETCH_ARBITRATION_EVENTS`,
);
export const fetchArbitrationEvents = makeApiActionCreatorV3(
  api.fetchArbitrationEvents,
  FETCH_ARBITRATION_EVENTS[START],
  FETCH_ARBITRATION_EVENTS[SUCCESS],
  FETCH_ARBITRATION_EVENTS[ERROR],
);

export const ARBITRATION_EVENT_DELETE = createRequestTypes(
  `${namespace}/ARBITRATION_EVENT_DELETE`,
);
export const deleteArbitrationEvent = makeApiActionCreatorV3(
  eventApi.deleteEvent,
  ARBITRATION_EVENT_DELETE[START],
  ARBITRATION_EVENT_DELETE[SUCCESS],
  ARBITRATION_EVENT_DELETE[ERROR],
);

export const FINALIZE_ARBITRATION = createRequestTypes(
  `${namespace}/FINALIZE_ARBITRATION`,
);
export const finalizeArbitration = makeApiActionCreatorV3(
  api.finalizeArbitration,
  FINALIZE_ARBITRATION[START],
  FINALIZE_ARBITRATION[SUCCESS],
  FINALIZE_ARBITRATION[ERROR],
);

export const LOCK_ARBITRATION = createRequestTypes(
  `${namespace}/LOCK_ARBITRATION`,
);
export const lockArbitration = makeApiActionCreatorV3(
  api.lockArbitration,
  LOCK_ARBITRATION[START],
  LOCK_ARBITRATION[SUCCESS],
  LOCK_ARBITRATION[ERROR],
);

export const REOPEN_ARBITRATION = createRequestTypes(
  `${namespace}/REOPEN_ARBITRATION`,
);
export const reopenArbitration = makeApiActionCreatorV3(
  api.reopenArbitration,
  REOPEN_ARBITRATION[START],
  REOPEN_ARBITRATION[SUCCESS],
  REOPEN_ARBITRATION[ERROR],
);
export const unlockArbitration = makeApiActionCreatorV3(
  api.unlockArbitration,
  REOPEN_ARBITRATION[START],
  REOPEN_ARBITRATION[SUCCESS],
  REOPEN_ARBITRATION[ERROR],
);

export const FETCH_ARBITRATION_HEARING = createRequestTypes(
  `${namespace}/FETCH_ARBITRATION_HEARING`,
);
export const fetchArbitrationHearing = makeApiActionCreatorV3(
  api.fetchArbitrationHearing,
  FETCH_ARBITRATION_HEARING[START],
  FETCH_ARBITRATION_HEARING[SUCCESS],
  FETCH_ARBITRATION_HEARING[ERROR],
);

export const UPDATE_ARBITRATION_HEARING = createRequestTypes(
  `${namespace}/UPDATE_ARBITRATION_HEARING`,
);
export const updateArbitrationHearing = makeApiActionCreatorV3(
  api.updateArbitrationHearing,
  UPDATE_ARBITRATION_HEARING[START],
  UPDATE_ARBITRATION_HEARING[SUCCESS],
  UPDATE_ARBITRATION_HEARING[ERROR],
);

export const FETCH_AVAILABLE_AGENTS = createRequestTypes(
  `${namespace}/FETCH_AVAILABLE_AGENTS`,
);
export const fetchAvailableAgents = makeApiActionCreatorV3(
  api.fetchAvailableAgents,
  FETCH_AVAILABLE_AGENTS[START],
  FETCH_AVAILABLE_AGENTS[SUCCESS],
  FETCH_AVAILABLE_AGENTS[ERROR],
);

export const FETCH_AVAILABLE_OWNERS = createRequestTypes(
  `${namespace}/FETCH_AVAILABLE_OWNERS`,
);
export const fetchAvailableOwners = makeApiActionCreatorV3(
  api.fetchAvailableOwners,
  FETCH_AVAILABLE_OWNERS[START],
  FETCH_AVAILABLE_OWNERS[SUCCESS],
  FETCH_AVAILABLE_OWNERS[ERROR],
);

export const ADD_ARBITRATION_MARKET_AREA_EVIDENCE = createRequestTypes(
  `${namespace}/ADD_ARBITRATION_MARKET_AREA_EVIDENCE`,
);
export const addArbitrationMarketAreaEvidence = makeApiActionCreatorV3(
  api.addArbitrationMarketAreaEvidence,
  ADD_ARBITRATION_MARKET_AREA_EVIDENCE[START],
  ADD_ARBITRATION_MARKET_AREA_EVIDENCE[SUCCESS],
  ADD_ARBITRATION_MARKET_AREA_EVIDENCE[ERROR],
);

export const ADD_ARBITRATION_COMMERCIAL_EVIDENCE = createRequestTypes(
  `${namespace}/ADD_ARBITRATION_COMMERCIAL_EVIDENCE`,
);
export const addArbitrationCommercialEvidence = makeApiActionCreatorV3(
  api.addArbitrationCommercialEvidence,
  ADD_ARBITRATION_COMMERCIAL_EVIDENCE[START],
  ADD_ARBITRATION_COMMERCIAL_EVIDENCE[SUCCESS],
  ADD_ARBITRATION_COMMERCIAL_EVIDENCE[ERROR],
);

export const FETCH_PROPOSED_ROLL_CORRECTIONS = createRequestTypes(
  `${namespace}/FETCH_PROPOSED_ROLL_CORRECTIONS`,
);
export const fetchProposedRollCorrections = makeApiActionCreatorV3(
  api.fetchProposedRollCorrections,
  FETCH_PROPOSED_ROLL_CORRECTIONS[START],
  FETCH_PROPOSED_ROLL_CORRECTIONS[SUCCESS],
  FETCH_PROPOSED_ROLL_CORRECTIONS[ERROR],
);

// fetchDisposition
export const FETCH_DISPOSITION = createRequestTypes(
  `${namespace}/FETCH_DISPOSITION`,
);
export const fetchDisposition = makeApiActionCreatorV3(
  api.fetchDisposition,
  FETCH_DISPOSITION[START],
  FETCH_DISPOSITION[SUCCESS],
  FETCH_DISPOSITION[ERROR],
);

export const FETCH_PRESENTATION_AVAILABLE_PROPERTY_COMPONENTS = createRequestTypes(
  `${namespace}/FETCH_PRESENTATION_AVAILABLE_PROPERTY_COMPONENTS`,
);
export const fetchPresentationAvailablePropertyComponents = makeApiActionCreatorV3(
  api.fetchPresentationAvailablePropertyComponents,
  FETCH_PRESENTATION_AVAILABLE_PROPERTY_COMPONENTS[START],
  FETCH_PRESENTATION_AVAILABLE_PROPERTY_COMPONENTS[SUCCESS],
  FETCH_PRESENTATION_AVAILABLE_PROPERTY_COMPONENTS[ERROR],
);

export const FETCH_PRESENTATION_AVAILABLE_ARTIFACTS = createRequestTypes(
  `${namespace}/FETCH_PRESENTATION_AVAILABLE_ARTIFACTS`,
);
export const fetchPresentationAvailableArtifacts = makeApiActionCreatorV3(
  api.fetchPresentationAvailableArtifacts,
  FETCH_PRESENTATION_AVAILABLE_ARTIFACTS[START],
  FETCH_PRESENTATION_AVAILABLE_ARTIFACTS[SUCCESS],
  FETCH_PRESENTATION_AVAILABLE_ARTIFACTS[ERROR],
);

export const FETCH_ARBITRATION_INCOME_MODELS = createRequestTypes(
  `${namespace}/FETCH_ARBITRATION_INCOME_MODELS`,
);
export const fetchArbitrationIncomeModels = makeApiActionCreatorV3(
  api.fetchArbitrationIncomeModels,
  FETCH_ARBITRATION_INCOME_MODELS[START],
  FETCH_ARBITRATION_INCOME_MODELS[SUCCESS],
  FETCH_ARBITRATION_INCOME_MODELS[ERROR],
);

export const FETCH_ARBITRATION_INCOME_ACTUALS = createRequestTypes(
  `${namespace}/FETCH_ARBITRATION_INCOME_ACTUALS`,
);
export const fetchArbitrationIncomeActuals = makeApiActionCreatorV3(
  api.fetchArbitrationIncomeActuals,
  FETCH_ARBITRATION_INCOME_ACTUALS[START],
  FETCH_ARBITRATION_INCOME_ACTUALS[SUCCESS],
  FETCH_ARBITRATION_INCOME_ACTUALS[ERROR],
);

export const FETCH_ARBITRATION_COMMERCIAL_EVIDENCE_CONFIG = createRequestTypes(
  `${namespace}/FETCH_ARBITRATION_COMMERCIAL_EVIDENCE_CONFIG`,
);
export const fetchArbitrationCommercialEvidenceConfig = makeApiActionCreatorV3(
  api.fetchArbitrationCommercialEvidenceConfig,
  FETCH_ARBITRATION_COMMERCIAL_EVIDENCE_CONFIG[START],
  FETCH_ARBITRATION_COMMERCIAL_EVIDENCE_CONFIG[SUCCESS],
  FETCH_ARBITRATION_COMMERCIAL_EVIDENCE_CONFIG[ERROR],
);
